import { Tab, TabList, TabPanel, TabPanels, Tabs } from "@chakra-ui/react";
import React from "react";
import DteDailyBooksTable from "./DteDailyBooksTable";
import DteMonthlyBooksTable from "./DteMonthlyBooksTable";
import DteLibrosCronJobsPanel from "./DteLibrosCronJobsPanel";

export default function DteLibrosPage() {
  return (
    <div className="mt-3 flex flex-col gap-4">
      <div>
        <h3 className="text-2xl font-bold text-navy-700 dark:text-white">
          DTE Libros
        </h3>
        <p className="mt-1 text-sm text-gray-600 dark:text-gray-400">
          Libros diarios y mensuales persistidos en base de datos, y opción para
          activar los cron jobs SII. Usá las pestañas para cambiar de sección.
        </p>
      </div>

      <Tabs
        colorScheme="brand"
        variant="enclosed"
        isLazy
        className="w-full"
      >
        <TabList className="flex-wrap gap-1 border-b border-gray-200 dark:border-white/10">
          <Tab
            fontWeight="600"
            _selected={{
              color: "brand.600",
              borderColor: "brand.500",
              borderBottomColor: "transparent",
            }}
          >
            Diarios
          </Tab>
          <Tab
            fontWeight="600"
            _selected={{
              color: "brand.600",
              borderColor: "brand.500",
              borderBottomColor: "transparent",
            }}
          >
            Mensuales
          </Tab>
          <Tab
            fontWeight="600"
            _selected={{
              color: "brand.600",
              borderColor: "brand.500",
              borderBottomColor: "transparent",
            }}
          >
            Cron jobs
          </Tab>
        </TabList>
        <TabPanels>
          <TabPanel px={0} pt={4}>
            <DteDailyBooksTable />
          </TabPanel>
          <TabPanel px={0} pt={4}>
            <DteMonthlyBooksTable />
          </TabPanel>
          <TabPanel px={0} pt={4}>
            <DteLibrosCronJobsPanel />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </div>
  );
}
